import {useTranslation} from 'react-i18next';

import {PersonCell} from '@/components';

import type {GuestAccountInviter} from '../utils';
import type {FC} from 'react';

export interface GuestInviterCellProps {
  inviter: GuestAccountInviter | null;
}

/** Who shared the account with the guest; a dash when the identity lookup failed. */
export const GuestInviterCell: FC<GuestInviterCellProps> = ({inviter}) => {
  const {t} = useTranslation('guest');

  return (
    <PersonCell
      name={inviter?.name ? t('accounts.inviterName', {name: inviter.name}) : null}
      initialsSource={inviter?.name ?? null}
      avatarUrl={inviter?.picture ?? undefined}
      seed={inviter?.id}
      emptyLabel="—"
      size="default"
    />
  );
};
